import React from 'react';
import { Table } from 'antd';
import {
  DEFAULT_PAGE_SIZE,
  createPaginationState,
  withIndexColumn,
  mergeTablePagination
} from '../../config/table';

export { DEFAULT_PAGE_SIZE, createPaginationState, mergeTablePagination, withIndexColumn };

export default function DataTable({
  columns,
  pagination,
  showIndex = true,
  ...rest
}) {
  const mergedPagination = mergeTablePagination(pagination);
  const displayColumns = showIndex
    ? withIndexColumn(columns, mergedPagination)
    : columns;

  return (
    <Table
      columns={displayColumns}
      pagination={mergedPagination}
      {...rest}
    />
  );
}
